import React from 'react';
import { Screen, UserProfile } from '../App';

interface Props {
  user: UserProfile;
  navigate: (s: Screen) => void;
}

const ITEMS: { id: Screen; icon: string; title: string; desc: string; cta: string }[] = [
  { id: 'question', icon: '?', title: 'Günün sorusu', desc: 'Birbirimizi biraz daha duymak için.', cta: 'Aç' },
  { id: 'mood', icon: '≋', title: 'Bugünkü halimiz', desc: 'Günün rengi ikimizde nasıl kaldı?', cta: 'Seç' },
  { id: 'notes', icon: '✎', title: 'Gece notu', desc: 'Uyumadan önce bize kalacak küçük şeyler.', cta: 'Yaz' },
];

function toDative(name: string) {
  const lower = name.toLocaleLowerCase('tr-TR');
  const vowels = lower.match(/[aeıioöuü]/g);
  const lastVowel = vowels?.[vowels.length - 1] || 'a';
  const front = ['e', 'i', 'ö', 'ü'].includes(lastVowel);
  const endsWithVowel = /[aeıioöuü]$/i.test(lower);
  return `${name}'${endsWithVowel ? (front ? 'ye' : 'ya') : (front ? 'e' : 'a')}`;
}

export default function BondScreen({ user, navigate }: Props) {
  const partner = user.displayName === 'Serhat' ? 'Ayça' : 'Serhat';
  const partnerTo = toDative(partner);

  return (
    <main className="hub-screen">
      <header className="hub-hero">
        <p>Bağ</p>
        <h1>Bugünden bize kalanlar.</h1>
        <span>Bir soru, bir hal, bir not.</span>
      </header>

      <button className="affection-panel" onClick={() => navigate('imhere')}>
        <span className="affection-pulse" />
        <div>
          <p>Seni düşünüyorum</p>
          <h2>{partnerTo} bir işaret gönder.</h2>
        </div>
        <b>Gönder</b>
      </button>

      <section className="hub-list">
        {ITEMS.map(item => (
          <button key={item.id} className="hub-row" onClick={() => navigate(item.id)}>
            <span>{item.icon}</span>
            <div>
              <strong>{item.title}</strong>
              <small>{item.desc}</small>
            </div>
            <b>{item.cta}</b>
          </button>
        ))}
      </section>
    </main>
  );
}
